<template>
  <div :class="$style['pt-award-audit']">
    <pt-page-title :title="pageTitle" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey"></pt-page-title>
    <pt-page-menu-filter v-if="pageLoading" :tabs="awardTabs" v-model="selectTab" state="status"></pt-page-menu-filter>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
          <el-button type="primary" @click="filter()">筛选</el-button>
          <template v-if="isExport">
          <el-button type="primary" @click="exportOldToNewAudit()" :loading="exportLoading">导出</el-button>
          <el-button type="primary" @click="exportOldToNewAudit(true)" v-if="hasAllExport" :loading="exportLoading">导出全部记录</el-button>
          <el-button type="primary" @click="exportHistoryOldToNewAudit">导出历史</el-button>
          </template>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          <el-button v-if="isBatchAdutit" type="primary" @click="batchReview">批量审核</el-button>
          <el-button v-if="showBatchRefundButton" type="primary" @click="batchRefund">批量退款</el-button>
      </pt-page-factor-filter>
    <pt-award-audit-table v-if="isShowTable" :isShowSelect="isShowSelect" :tableLabels="awardTableLabel" :paramsData="paramsData" :business-type="businessType"
    ref="table"  @select="select" @selectAll="selectAll" :isFromRouter="isFromRouter" v-loading="loading" :list-sort="listSort">
      <template>
        <el-table-column label="客服备注" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.genericReward&&scope.row.genericReward.salesApprovalRemark">
              <el-tooltip :content="scope.row.genericReward.salesApprovalRemark" placement="top">
              <div :class="$style['remark-div']" v-popover:popover>
                {{scope.row.genericReward.salesApprovalRemark}}
              </div>
              </el-tooltip>
                    <!-- <div :class="$style['remark-div']" v-popover:popover>
                {{scope.row.genericReward.salesApprovalRemark}}
            <el-popover
              ref="popover"
              placement="top"
              width="200"
              title="客服备注"
              trigger="hover"
              :content="scope.row.genericReward.salesApprovalRemark">
            </el-popover>
            </div> -->
            </template>
            <template v-else>--</template>
          </template>
        </el-table-column>
        <!-- <el-table-column label="退款状态" fixed="right"> -->
        <el-table-column  label="退款状态" fixed="right">
          <template slot-scope="scope">
            {{scope.row.alreadyRefund?'已退款':'--'}}
          </template>
        </el-table-column>
        <el-table-column label="" fixed="right">
          <template slot-scope="scope">
            {{scope.row.alreadyRefund&&scope.row.refundMoney?scope.row.refundMoney:'--'}}
          </template>
        </el-table-column>
        <!-- </el-table-column> -->
          <el-table-column label="审核状态"  :key="Math.random()" min-width="110" fixed="right">
              <template slot-scope="scope">
                  <div :style="'color:'+(theRowIsReject(scope.row)?'#FF0000':'')">
                  {{scope.row.audit_status}}
                  </div>
              </template>
          </el-table-column>
        <el-table-column label="操作" min-width="105" :key="Math.random()" fixed="right">
            <template slot-scope="scope">
            <el-button type="text" :class="$style['award-audit-table-button']" @click="auditDetail(scope.row)">详情</el-button>
            <el-button  v-if="hasSeviceApproval(scope.row.genericReward)" type="text" :class="$style['award-audit-table-button']" @click="auditReview(scope.row.genericReward,scope.row.genericReward.status)">
            <!-- <el-button  v-if="(scope.row.status==='WAITING_FOR_APPROVAL'||scope.row.status==='REJECTED')&&HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT" type="text" :class="$style['award-audit-table-button']" @click="auditReview(scope.row,scope.row.status)"> -->
             {{approveButton(scope.row.genericReward,'sevice')}}
              </el-button>
            <el-button v-if="hasSaleApproval(scope.row.genericReward)" type="text" :class="$style['award-audit-table-button']" @click="auditReview(scope.row.genericReward,scope.row.genericReward.status)">
              {{approveButton(scope.row.genericReward,'saler')}}
              </el-button>
             <!-- <el-button type="text" v-if="isExpediteButton(scope.row)"  :class="$style['award-audit-table-button']" @click="oldCudtomerRemindPay(scope.row)">催费</el-button> -->
             <el-button type="text" :class="$style['award-audit-table-button']" v-if="showRefundBotton(scope.row.genericReward)" @click="rewardRefund(scope.row.genericReward)">退款</el-button>
            </template>
        </el-table-column>
      </template>
    </pt-award-audit-table>
    <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['review-coupon-dialog']" @close="closeDialog">
      <award-grant-review v-if="is_review||this.is_refund" :refundDialog="is_refund" :selectRows="selectRows" :statisticsData="statisticsData" :isBatch="isBatch"
      @getTableData="getTableData" @closeDialog="closeDialog" :selectTab="selectTab" :auditStatus="auditStatus" :userType="userType"
      :auditAlreadyRefund="auditAlreadyRefund"></award-grant-review>
      <award-result v-if="isShowResult" :resultContent="resultContent" @closeDialog="closeDialog"></award-result>
    </el-dialog>
  </div>
</template>

<script>
import ptAwardAuditTable from './pt-award-audit-table/withData'
import { awardTabs, awardTabsQJK, awardTableLabel, filterLabels } from './award-audit'
import awardResult from './award-result'
import awardGrantReview from './award-grant-review'
import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-award-audit'
const PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT = 'PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT'// 老带新客服审核权限
const PERM_MALLSALES_BRING_NEW_REWARD_AUDIT = 'PERM_MALLSALES_BRING_NEW_REWARD_AUDIT'// 老带新财务审核权限
const PERM_APPROVAL_ROUND_FIRST = 'PERM_APPROVAL_ROUND_FIRST'// 脐荐康第一轮奖励审核
const PERM_APPROVAL_ROUND_SECOND = 'PERM_APPROVAL_ROUND_SECOND'// 脐荐康第二轮奖励审核
const PERM_APPROVAL_ROUND_THIRD = 'PERM_APPROVAL_ROUND_THIRD'// 脐荐康第三轮奖励审核
const achieveDateFilter = {
  label: '达标时间',
  type: 'time-slot',
  value: 'achieveDate',
  clearable: true,
  startName: 'achieveDateStart',
  endName: 'achieveDateEnd'
}
const approvalDateFilter = {
  label: '审核时间',
  type: 'time-slot',
  clearable: true,
  value: 'approvalDate',
  startName: 'approvalDateStart',
  endName: 'approvalDateEnd'
}
// 是否催费筛选条件
const alReadyRemindFilter = {
  label: '催费状态',
  type: 'select',
  clearable: true,
  value: 'alReady_remind',
  options: [
    {
      label: '已催费',
      value: 'true'
    },
    {
      label: '未催费',
      value: 'false'
    }
  ]
}
export default {
  name: 'pt-award-audit',
  components: {
    ptAwardAuditTable,
    awardGrantReview,
    awardResult
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    statisticsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isReview: {
      type: Boolean,
      default: false
    },
    exportLoading: {
      type: Boolean,
      default: false
    },
    businessType: {
      type: String
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_review || this.isShowResult || this.is_refund
      },
      set: function (val) {
        this.is_review = val
        this.isShowResult = val
      }
    },
    hasAllExport () {
      return (this.selectTab === 'SALES_COMPLETED' || this.selectTab === 'COMPLETED') && this.businessType === 'CUSTOMER_BRING_NEW_QJK'
    },
    HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT () { // 老带新财务审核权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_BRING_NEW_REWARD_AUDIT)
    },
    HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT () { // 老带新奖励客服审核权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT)
    },
    // 脐荐康第一轮奖励审核权限
    HAS_PERM_APPROVAL_ROUND_FIRST () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_APPROVAL_ROUND_FIRST)
    },
    // 脐荐康第二轮奖励审核权限
    HAS_PERM_APPROVAL_ROUND_SECOND () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_APPROVAL_ROUND_SECOND)
    },
    // 脐荐康第三轮奖励审核权限
    HAS_PERM_APPROVAL_ROUND_THIRD () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_APPROVAL_ROUND_THIRD)
    },
    // 批量审核
    QJKbetchButton () {
      return (((this.selectTab === 'WAITING_FOR_APPROVAL_FIRST' && this.HAS_PERM_APPROVAL_ROUND_FIRST) || (this.selectTab === 'WAITING_FOR_APPROVAL_SECOND' && this.HAS_PERM_APPROVAL_ROUND_SECOND)) &&
      this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT) || (this.selectTab === 'SALES_COMPLETED' && this.HAS_PERM_APPROVAL_ROUND_SECOND && this.HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT)
    },
    // 是否可批量操作
    isBatchAdutit () {
      return (this.businessType === 'CUSTOMER_BRING_NEW_QJK' || !this.businessType) ? this.QJKbetchButton
        : ((this.selectTab === 'WAITING_FOR_APPROVAL' || this.selectTab === 'REJECTED') && this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT) || (this.selectTab === 'SALES_COMPLETED' && this.HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT)
    },
    // 是否可导出
    isExport () {
      return (this.businessType === 'CUSTOMER_BRING_NEW_QJK' || !this.businessType) ? (this.selectTab !== 'REJECTED_ALL' && this.selectTab !== 'REFUND') : this.selectTab === 'WAITING_FOR_APPROVAL' || this.selectTab === 'SALES_COMPLETED' || this.selectTab === 'ALL' || this.selectTab === 'COMPLETED'
    },
    // 是否显示首列选择框
    isShowSelect () {
      return this.isBatchAdutit || this.showBatchRefundButton
    },
    tableData () {
      return this.$refs.table.tableData
    },
    // 是否显示达标时间
    isShowAchieveDate () {
      return this.selectTab === 'ALL' || this.selectTab === 'WAITING_FOR_APPROVAL' || this.selectTab === 'SALES_COMPLETED'
    },
    // 是否需要筛选审核时间
    isShowApprovalTime () {
      return this.selectTab === 'SALES_COMPLETED' || this.selectTab === 'COMPLETED'
    },
    // 是否显示催费状态筛选
    isShowAlReadyRemindFilter () {
      return this.selectTab === 'WAITING_FOR_APPROVAL'
    },
    // 列表排序规则
    listSort () {
      return (this.selectTab === 'COMPLETED' || this.selectTab === 'SALES_COMPLETED') ? 'approvalDate'
        : ((this.selectTab === 'SALES_REJECTED' || this.selectTab === 'REJECTED') ? 'rejectDate' : 'rewardDate')
    },
    // 是否显示批量退款按钮
    showBatchRefundButton () {
      return this.selectTab === 'COMPLETED' && (this.HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT || this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT)
    },
    pageTitle () {
      let title
      switch (this.businessType) {
        case 'CUSTOMER_BRING_NEW_MOTHERS_DAY':
          title = '母亲节审核'
          break
        case 'CUSTOMER_BRING_NEW':
          title = '老带新审核'
          break
        default:
          title = '脐荐康审核'
          break
      }
      return title
    }
    // awardTabs () {
    //   return (this.businessType === 'CUSTOMER_BRING_NEW_QJK' || !this.businessType) ? awardTabsQJK : awardTabs
    // }
  },
  data () {
    return {
      selectTab: 'ALL',
      filterLabels: filterLabels,
      awardTableLabel: awardTableLabel,
      params: {},
      paramsData: {},
      isFromRouter: false,
      selectRows: [],
      dialog_title: '',
      is_review: this.isReview,
      isShowResult: false,
      isBatch: false,
      resultContent: null,
      auditStatus: null,
      userType: null,
      isShowTable: true,
      searchKey: null,
      auditAlreadyRefund: false,
      is_refund: false,
      pageLoading: true,
      awardTabs: (this.businessType === 'CUSTOMER_BRING_NEW_QJK' || !this.businessType) ? awardTabsQJK : awardTabs
    }
  },
  watch: {
    businessType (val) {
      this.awardTabs = (val === 'CUSTOMER_BRING_NEW_QJK' || !val) ? awardTabsQJK : awardTabs
      this.selectTab = 'ALL'
      this.paramsData.status = null
      this.paramsData = {}
      this.params = {}
      this.searchKey = null
      this.pageLoading = false
      setTimeout(() => {
        this.pageLoading = true
      })
      // location.reload()
    },
    selectTab: {
      handler: function (val) {
        this.isShowTable = false
        this.selectRows = []
        this.$nextTick(_ => {
          this.isShowTable = true
        })
        for (var key in this.paramsData) {
          this.$delete(this.paramsData, key)
        }
        for (var key1 in this.params) {
          this.$delete(this.params, key1)
        }
        this.tabsData(val)
        this.$refs.table && this.$refs.table.resetPage()
        this.filterLabelsData()
      },
      immediate: true
    },
    isReview (val) {
      this.$set(this, 'is_review', val)
      this.dialog_title = this.auditStatus === 'SALES_COMPLETED' ? '财务审核' : '客服审核'
    }
  },
  methods: {
    // 审核按钮显示
    approveButton (row, role) {
      let rewardCount = row.extendInformation && row.extendInformation.customerBringNew && row.extendInformation.customerBringNew.finalRewardCount
      let buttonOfQJK = role === 'saler' ? (rewardCount === '第一轮' ? '地区财务审核' : '总部财务审核') : (rewardCount === '第一轮' ? '审核' : '总部客服审核')
      let buttonOfBingNew = role === 'saler' ? '财务审核' : '客服审核'
      return row.businessType === 'CUSTOMER_BRING_NEW_QJK'
        ? buttonOfQJK : buttonOfBingNew
    },
    // 奖励权限和轮系对应
    rewardCountToPerm (row) {
      let rewardCount = row.extendInformation && row.extendInformation.customerBringNew && row.extendInformation.customerBringNew.finalRewardCount
      return (rewardCount === '第一轮' && this.HAS_PERM_APPROVAL_ROUND_FIRST) || (rewardCount === '第二轮' && this.HAS_PERM_APPROVAL_ROUND_SECOND) ||
      (rewardCount === '第三轮' && this.HAS_PERM_APPROVAL_ROUND_THIRD)
    },
    hasSaleApproval (row) {
      return row.status === 'SALES_COMPLETED' && (row.businessType === 'CUSTOMER_BRING_NEW_QJK'
        ? (this.HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT && this.rewardCountToPerm(row)) : this.HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT)
    },
    hasSeviceApproval (row) {
      return (row.status === 'WAITING_FOR_APPROVAL' &&
      row.businessType === 'CUSTOMER_BRING_NEW_QJK')
        ? (this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT && this.rewardCountToPerm(row)) : ((row.status === 'WAITING_FOR_APPROVAL' || row.status === 'REJECTED') && this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT)
    },
    // tabs数据选择处理
    tabsData (val) {
      if (val !== 'ALL') {
        switch (val) {
          case 'REFUND':
            this.$set(this.paramsData, 'alreadyRefund', true)
            break
          case 'REJECTED_ALL':
            this.paramsData.queryStatus = val
            break
          case 'WAITING_FOR_APPROVAL_FIRST':
            this.paramsData.status = 'WAITING_FOR_APPROVAL'
            this.paramsData.rewardCount = 1
            break
          case 'WAITING_FOR_APPROVAL_SECOND':
            this.paramsData.status = 'WAITING_FOR_APPROVAL'
            this.paramsData.rewardCount = 2
            break
          default:
            this.paramsData.status = val
            break
        }
      }
    },
    batchRefund () {
      this.is_refund = true
      this.auditStatus = this.selectRows[0].genericReward.status
      this.dialog_title = '批量退款'
    },
    showRefundBotton (row) {
      return row.showRefund && (this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT || this.HAS_PERM_MALLSALES_BRING_NEW_REWARD_AUDIT)
    },
    rewardRefund (row) {
      this.selectRows = []
      this.is_refund = true
      this.auditStatus = row.status
      this.selectRows.push(row)
      this.dialog_title = '退款'
    },
    search (val) {
      this.searchKey = val
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch () {
      this.$delete(this.queryParams, 'searchKey')
    },
    filterLabelsData () {
      // 是否包含达标时间
      let isArrayInclundAchieve = JSON.stringify(this.filterLabels).indexOf(JSON.stringify(achieveDateFilter)) < 0
      if (this.isShowAchieveDate) {
        if (isArrayInclundAchieve) {
          this.filterLabels.splice(2, 0, achieveDateFilter)
        }
      } else {
        if (!isArrayInclundAchieve) {
          this.filterLabels.forEach((item, index) => {
            if (item.value === 'achieveDate') {
              this.filterLabels.splice(index, 1)
            }
          })
        }
      }
      // 是否不包含审核时间
      let isArrayInclundApproval = JSON.stringify(this.filterLabels).indexOf(JSON.stringify(approvalDateFilter)) < 0
      if (this.isShowApprovalTime) {
        approvalDateFilter.label = this.selectTab === 'SALES_COMPLETED' ? '客服审核时间' : '财务审核时间'
        if (this.selectTab === 'SALES_COMPLETED' && isArrayInclundApproval) {
          this.filterLabels.splice(3, 0, approvalDateFilter)
        } else if (this.selectTab === 'COMPLETED' && isArrayInclundApproval) {
          this.filterLabels.splice(2, 0, approvalDateFilter)
        }
      } else {
        if (!isArrayInclundApproval) {
          this.filterLabels.forEach((item, index) => {
            if (item.value === 'approvalDate') {
              this.filterLabels.splice(index, 1)
            }
          })
        }
      }
      // 筛选条件是否不包含催费状态
      let isIncludAlReadyRemindFilter = JSON.stringify(this.filterLabels).indexOf(JSON.stringify(alReadyRemindFilter)) < 0
      if (this.isShowAlReadyRemindFilter) {
        if (isIncludAlReadyRemindFilter) {
          // this.filterLabels.splice(this.filterLabels.length, 0, alReadyRemindFilter)
        }
      } else {
        if (!isIncludAlReadyRemindFilter) {
          this.filterLabels.forEach((item, index) => {
            if (item.value === 'alReady_remind') {
              this.filterLabels.splice(index, 1)
            }
          })
        }
      }
    },
    exportOldToNewAudit (isAll) {
      if ((!isAll && this.tableData && this.tableData.length) || isAll) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key in this.params) {
            if (key === 'contractDate') {
              params = { ...this.params, ...this.params.contractDate }
              this.$delete(params, 'contractDate')
              this.$delete(params, 'index')
            }
            if (key === 'registerDate') {
              params = { ...this.params, ...this.params.registerDate }
              this.$delete(params, 'registerDate')
              this.$delete(params, 'index')
            }
            if (key === 'approvalDate') {
              this.params = { ...this.params, ...this.params.approvalDate }
              this.$delete(this.params, 'approvalDate')
              this.$delete(this.params, 'index')
            }
            if (key === 'achieveDate') {
              this.params = { ...this.params, ...this.params.achieveDate }
              this.$delete(this.params, 'achieveDate')
              this.$delete(this.params, 'index')
            }
            if (key === 'oldBind') {
              params.oldBind = params.oldBind === 'true'
            }
            if (key === 'alReady_remind') {
              params.alReadyRemind = this.params[key] === 'true' ? true : (this.params[key] === 'false' ? false : null)
              if (this.params[key]) {
                this.$set(params, 'userType', 'OLD')
                this.$set(this.params, 'userType', 'OLD')
              }
            }
            this.$delete(params, 'state')
          }
          for (let key1 in params) {
            if (!params[key1] && params[key1] !== false) {
              this.$delete(params, key1)
            }
          }
          if (this.selectTab !== 'ALL') {
            params.status = this.selectTab
          }
          if (!isAll) {
            params.businessType = this.businessType
          }
          this.tabsData(this.selectTab)
          params = { ...params, ...this.paramsData }
          params.status = isAll ? 'COMPLETED' : params.status
          this.$emit('BringNewAuditExport', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryOldToNewAudit () {
      this.$router.push('/export-history/old_to_new_audit/?name=bring_new_reward_audit_export')
    },
    oldCudtomerRemindPay (row) {
      this.$confirm('您是否确认向该用户发送催费短信', '催费提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        let ids = []
        ids.push(row.id)
        this.$emit('oldCudtomerRemindPay', ids)
      })
    },
    // 是否显示催费按钮
    isExpediteButton (row) {
      return row.extendInformation.userType === 'OLD' && row.status === 'WAITING_FOR_APPROVAL' && this.HAS_PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT && row.cpsBind
    },
    theRowIsReject (row) {
      return row.status === 'REJECTED' || row.status === 'SALES_REJECTED'
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    getTableData () {
      this.$nextTick(_ => {
        this.$refs.table.getTableData()
      })
    },
    closeDialog (val, showResult, resultContent) {
      this.is_dialog = false
      this.is_review = false
      this.is_refund = false
      this.userType = null
      this.$emit('closeDialog')
      if (val) {
        this.$refs.table.getTableData()
      }
      if (showResult) {
        this.isShowResult = true
        this.resultContent = resultContent
      }
    },
    auditDetail (row) {
      this.$router.push('/reward-grant-audit/award-audit-detail/' + row.id)
    },
    batchReview () {
      if (this.selectRows && this.selectRows.length > 0) {
        let ids = []
        let text = this.selectTab === 'SALES_COMPLETED' ? '财务' : '客服'
        this.$confirm('您是否确认' + text + '批量审核', '确认' + text + '审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.selectRows.forEach(item => {
            this.auditStatus = item.status
            this.auditAlreadyRefund = item.alreadyRefund
            ids.push(item.id)
            this.dialog_title = this.auditStatus === 'SALES_COMPLETED' ? '财务审核' : '客服审核'
            this.is_review = true
          })
          this.isBatch = true
          // this.$emit('auditReview', ids, this.auditStatus)
        })
      } else {
        this.$message.error('请勾选需要审核的奖励记录')
      }
    },
    select (selection, row) {
      this.selectRows = []
      let genericReward = selection[0] && selection[0].genericReward
      let genericRewardOfRow = row.genericReward
      let selectedType = genericReward.businessDescription
      let rowType = genericRewardOfRow.businessDescription
      let selectedFinalRewardCount = genericReward.extendInformation && genericReward.extendInformation.customerBringNew && genericReward.extendInformation.customerBringNew.finalRewardCount
      let rowFinalRewardCount = genericRewardOfRow.extendInformation && genericRewardOfRow.extendInformation.customerBringNew && genericRewardOfRow.extendInformation.customerBringNew.finalRewardCount
      let rowAlreadyRefund = genericRewardOfRow.alreadyRefund
      let selectedAlreadyRefund = genericReward.alreadyRefund
      if ((selectedFinalRewardCount !== rowFinalRewardCount || selectedType !== rowType || rowAlreadyRefund !== selectedAlreadyRefund) && selection.length) {
        this.$message.error('请选择同类型/同轮次/对应订单同退款状态的老带新奖励记录')
      }
      selection.forEach((item, index) => {
        if (selection.length > 1) {
          if (selectedFinalRewardCount === rowFinalRewardCount && selectedType === rowType) {
            this.selectRows.push(item.genericReward)
          } else {
            if (item.id === row.id) {
              selection.splice(index, 1)
            } else {
              this.selectRows.push(item.genericReward)
            }
          }
        } else {
          this.selectRows.push(item.genericReward)
        }
      })
    },
    selectAll (rows) {
      this.selectRows = []
      rows.forEach(item => {
        this.selectRows.push(item.genericReward)
      })
    },
    auditReview (row, status) {
      this.isBatch = true
      this.selectRows = []
      this.selectRows.push(row)
      this.auditAlreadyRefund = row.alreadyRefund
      let ids = []
      //   let text = status === 'SALES_COMPLETED' ? '财务' : '客服'
      //   this.$confirm('您是否确认' + text + '审核该记录', '确认' + text + '审核', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning' }).then(_ => {
      this.auditStatus = row.status
      ids.push(row.id)
      this.userType = row.extendInformation.userType
      this.is_review = true
      this.dialog_title = this.auditStatus === 'SALES_COMPLETED' ? '财务审核' : '客服审核'
    //   this.$emit('auditReview', ids, this.auditStatus)
    //   })
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      console.log('this.paramsData++---', this.params)
      for (var key in this.params) {
        if (key === 'contractDate') {
          this.params = { ...this.params, ...this.params.contractDate }
          this.$delete(this.params, 'contractDate')
          this.$delete(this.params, 'index')
        }
        if (key === 'registerDate') {
          this.params = { ...this.params, ...this.params.registerDate }
          this.$delete(this.params, 'registerDate')
          this.$delete(this.params, 'index')
        }
        if (key === 'approvalDate') {
          this.params = { ...this.params, ...this.params.approvalDate }
          this.$delete(this.params, 'approvalDate')
          this.$delete(this.params, 'index')
        }
        if (key === 'achieveDate') {
          this.params = { ...this.params, ...this.params.achieveDate }
          this.$delete(this.params, 'achieveDate')
          this.$delete(this.params, 'index')
        }
        if (key === 'alReady_remind') {
          this.params.alReadyRemind = this.params[key] === 'true' ? true : (this.params[key] === 'false' ? false : null)
          if (this.params[key]) {
            this.$set(this.params, 'userType', 'OLD')
          }
        }
      }
      // this.paramsData.status = this.selectTab === 'ALL' ? null : this.selectTab
      this.paramsData = { ...this.paramsData, ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
      for (var key2 in this.paramsData) {
        if (!this.paramsData[key2] && this.paramsData[key2] !== false) {
          this.$delete(this.paramsData, key2)
        }
      }
      if (this.params.status && this.params.status === 'ALL') {
        this.$delete(this.params, 'status')
        this.$delete(this.paramsData, 'status')
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
    }
  },
  created () {
    this.filterLabelsData()
    // let businessType = this.businessType || 'CUSTOMER_BRING_NEW_QJK'
    // this.$set(this.paramsData, 'businessType', businessType)
    // this.filterLabels.splice(2, 0, achieveDateFilter)
    this.selectTab = this.$route.query.status
    // this.paramsData.status = this.selectTab && this.selectTab !== 'ALL' ? this.selectTab : null
    console.log('this.paramsData', this.paramsData)
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.remark-div{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.award-audit-table-button{
  margin-left: 0!important;
  margin-right: 10px;
}
</style>
